/* eslint-disable no-restricted-globals */
import React from 'react';
import { Box, Button, HStack, Text, Img, chakra } from '@chakra-ui/react';
import { useGoogleLogin } from '@react-oauth/google';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Google } from '../../../assets/icons/google.svg';
interface IOAuthOptions {
  description?: string;
}

const GoogleIcon = Google as any;

const PROD_URL =
  'https://launchpad.classlink.com/oauth2/v2/auth?scope=full&redirect_uri=https%3A%2F%2Flab.stemi.education/sign-in/callback&client_id=c16589257355013b0cc96518bb99ba1180afc4a21f19&response_type=code';
const TEST_URL =
  'https://launchpad.classlink.com/oauth2/v2/auth?scope=full&redirect_uri=http%3A%2F%2Flocalhost%3A8000%2Fsign-in%2Fcallback&client_id=c1658925735501f5367d7f80e59ca0ba35cd6a679858&response_type=code';

const AAI_TEST_URL =
  'https://login.aaiedu.hr/sso/module.php/oidc/authorize.php?response_type=code&client_id=f7b3660b-a45e-4284-91ca-bd629032e52a&redirect_uri=http://localhost:8000/sign-in/callback/&scope=email openid displayName givenName hrEduPersonAffiliation hrEduPersonPersistentID hrEduPersonRole sn&state=aaiedu&code_challenge=0BrH7lYSPAV-UvAOY7iNcNzvXbBpiYCkiDQYsMBNTOI&code_challenge_method=S256';

const AAI_PROD_URL =
  'https://login.aaiedu.hr/sso/module.php/oidc/authorize.php?response_type=code&client_id=f7b3660b-a45e-4284-91ca-bd629032e52a&redirect_uri=https://lab.stemi.education/sign-in/callback/&scope=email openid displayName givenName hrEduPersonAffiliation hrEduPersonPersistentID hrEduPersonRole sn&state=aaiedu&code_challenge=0BrH7lYSPAV-UvAOY7iNcNzvXbBpiYCkiDQYsMBNTOI&code_challenge_method=S256';

const _oAuthOptions = (props: IOAuthOptions) => {
  const { t } = useTranslation();
  const { description } = props;
  const { hostname } = window.location;
  const isLocalhost = hostname === 'localhost';
  const classlink_callback_url = isLocalhost ? TEST_URL : PROD_URL;
  const clever_client_id =
    hostname === 'lab.stemi.education'
      ? 'd6f6846162f771bcf4c4'
      : '7ead77b3cb9b0bf08e03';
  const clever_callback_url = isLocalhost
    ? `https://clever.com/oauth/authorize?response_type=code&redirect_uri=http%3A%2F%2Flocalhost%3A8000%2Fsign-in%2Fclever%2Fcallback%2F&client_id=${clever_client_id}`
    : `https://clever.com/oauth/authorize?response_type=code&redirect_uri=https%3A%2F%2F${hostname}%2Fsign-in%2Fclever%2Fcallback%2F&client_id=${clever_client_id}`;
  const login = useGoogleLogin({
    onSuccess: console.log,
    onError: console.log,
    flow: 'auth-code',
    redirect_uri: isLocalhost
      ? 'http://localhost:8000/sign-in/callback/'
      : `https://${hostname}/sign-in/callback/`,
    ux_mode: 'redirect',
  });

  const aaieduLogin = () => {
    location.href = isLocalhost ? AAI_TEST_URL : AAI_PROD_URL;
  };

  const LOGIN_BUTTONS_STYLE = {
    width: '260px',
    height: '45px',
  };

  return (
    <Box
      textAlign="center"
      {...props}
      style={{ marginTop: '10px', padding: '10px' }}
    >
      <Text fontSize="sm" color="gray.500">
        {description || t('oauthOptions.otherSignInOptions')}
      </Text>
      <HStack
        padding={4}
        display="grid"
        gridTemplateColumns={{
          base: '1fr',
          md: 'repeat(2, 1fr)',
        }}
        gridGap="10px"
        justifyItems="center"
        alignItems="center"
      >
        <a
          style={{ ...LOGIN_BUTTONS_STYLE, marginLeft: '0.6rem' }}
          href={classlink_callback_url}
          className="login-button-link w-inline-block"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src="https://assets-global.website-files.com/5d6db64572061db9c481aaeb/601834763c34b1739330e905_classlink-login-button-small.png"
            alt="ClassLink Login Button"
            style={{
              ...LOGIN_BUTTONS_STYLE,
              borderRadius: '4px',
              alignSelf: 'right',
            }}
          />
        </a>
        <Button
          onClick={login}
          background="#2673e4"
          colorScheme="facebook"
          color="#FFF"
          style={LOGIN_BUTTONS_STYLE}
          leftIcon={
            <Box p={2} background="#FFF" borderRadius={4}>
              <GoogleIcon width="20px" height="20px" />
            </Box>
          }
        >
          {t('oauthOptions.Google')}
        </Button>
        <Button
          onClick={aaieduLogin}
          background="#2673e4"
          colorScheme="twitter"
          color="#FFF"
          style={LOGIN_BUTTONS_STYLE}
          leftIcon={
            <Box p={2} background="#FFF" borderRadius={4}>
              <Img src="/static/ui/aaiedu.png" width="20px" height="20px" />
            </Box>
          }
        >
          {t('oauthOptions.EduHR')}
        </Button>
        <a
          style={LOGIN_BUTTONS_STYLE}
          href={clever_callback_url}
          className="login-button-link w-inline-block"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src="/static/ui/clever.png"
            alt="Log in with Clever"
            style={{ ...LOGIN_BUTTONS_STYLE, borderRadius: '4px' }}
          />
        </a>
      </HStack>
    </Box>
  );
};

const OAuthOptions = chakra(_oAuthOptions);
export { OAuthOptions };
export default OAuthOptions;
